import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Userprofile } from '../../core/entities/userprofile.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserprofileService {
    readonly BASE: any = PETICIONES.userprofile;

    constructor(private http: HttpClient) { }

    /**
    * @description
    * Guarda un userprofile en la base de datos
    */
    public postUserprofile(user: Userprofile): Observable<any> {
        const json = JSON.stringify(user);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postUserprofile, json, {headers: headers}).pipe(delay(DELAY));
    }

    /**
    * @description
    * Borra un userprofile en la base de datos
    */
    public deleteUserprofile(user: Userprofile): Observable<any> {
        let iduserprofile: string = (user.id !== undefined && user.id !== null ? user.id + "" : "");
        return this.http.get(this.BASE.deleteCas + "/" + iduserprofile).pipe(delay(DELAY));
    }
}